<textarea #editor class="kothing-html-editor-input"></textarea>